<template lang="html">

  <section class="new-trip">
    <div class="pageHeading">
      <h1 v-if="!isExisting">Create New Trip</h1>
      <h1 v-else>Edit Trip</h1>
    </div>



      <v-dialog v-model="newBussinessDialog" persistent max-width="80%">
          <v-card>
              <v-toolbar dark color="primary">
                  <v-btn icon dark @click="newBussinessDialog = false">
                      <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>Add/Update - Business / School</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                      <v-btn v-if="editingBusinessID != null" flat @click="updateBusiness()">update Business</v-btn>
                      <v-btn v-else flat @click="createBusiness()">Create Business</v-btn>
                  </v-toolbar-items>
              </v-toolbar>


              <new-business v-model="businessDataFromModal" :business="editingBusinessID" modal="true"></new-business>
          </v-card>
      </v-dialog>



      <v-card>
      <v-list two-line>
          <v-list-tile class="mainSectionHeadingInList" @click="">
              <v-list-tile-action>
                  <v-icon color="indigo">assignment</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-list-tile-title>Basic Information</v-list-tile-title>
              </v-list-tile-content>

          </v-list-tile>

          <v-list-tile @click="">
              <v-list-tile-action>
              </v-list-tile-action>

              <v-list-tile-content>

                  <v-text-field
                          v-validate="'required'"
                          v-model="tripData.tripID"
                          label="Trip ID"
                          required
                          :disabled="isExisting"
                  ></v-text-field>
              </v-list-tile-content>
              <v-list-tile-content>

                  <v-text-field
                          v-validate="'required'"
                          v-model="tripData.tripName"
                           size="50"
                          label="Trip Name"
                          required
                          :disabled="tripData.disabled"
                  ></v-text-field>
              </v-list-tile-content>

            <v-list-tile-content>

              <v-text-field
                  v-validate="'required'"
                  v-model="tripData.tripDestination"
                  size="50"
                  label="Trip Destination"
                  required
                  :disabled="tripData.disabled"
              ></v-text-field>
            </v-list-tile-content>

            <v-list-tile-content>

              <v-text-field
                  v-model="tripInviteLink"
                  size="50"
                  label="Trip Invite Link"
                  :readonly="true"
              ></v-text-field>
            </v-list-tile-content>

          </v-list-tile>

          <v-list-tile @click="">
              <v-list-tile-action>
              </v-list-tile-action>

              <v-list-tile-content>

                  <v-text-field
                          v-validate="'required'"
                          v-model="tripData.depositAmount"
                          type="number"
                          label="Deposit: $"
                          required
                          :disabled="tripData.disabled"
                  ></v-text-field>

              </v-list-tile-content>

              <v-list-tile-content>


                  <v-dialog
                          ref="dialogDepart"
                          v-model="modalDepart"
                          :return-value.sync="tripData.departDate"
                          persistent
                          lazy
                          full-width
                          width="290px"
                          :disabled="tripData.disabled"
                  >
                      <v-text-field
                              slot="activator"
                              :value="formatDate(tripData.departDate)"
                              label="Trip Departure Date"
                              prepend-icon="event"
                              readonly
                      ></v-text-field>
                      <v-date-picker
                               v-model="tripData.departDate" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modalDepart = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.dialogDepart.save(tripData.departDate); tripData.returnDate = tripData.departDate">OK</v-btn>
                      </v-date-picker>
                  </v-dialog>

              </v-list-tile-content>
              <v-list-tile-content>

                  <v-dialog
                          ref="dialogReturn"
                          v-model="modalReturn"
                          :return-value.sync="tripData.returnDate"
                          persistent
                          lazy
                          full-width
                          width="290px"
                          :disabled="tripData.disabled"
                  >
                      <v-text-field
                              slot="activator"
                              :value="formatDate(tripData.returnDate)"
                              label="Trip Return Date"
                              prepend-icon="event"
                              readonly
                      ></v-text-field>
                      <v-date-picker :min="toISO(tripData.departDate, -1)" v-model="tripData.returnDate" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modalReturn = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.dialogReturn.save(tripData.returnDate)">OK</v-btn>
                      </v-date-picker>
                  </v-dialog>
              </v-list-tile-content>

              <v-list-tile-content>

                  <v-text-field
                          v-validate="'required'"
                          v-model="tripData.participantLimit"
                          type="number"
                          label="Max Participants: #"
                          required
                          :disabled="tripData.disabled"
                  ></v-text-field>

              </v-list-tile-content>

          </v-list-tile>



          <v-list-tile class="mainSectionHeadingInList" @click="">
              <v-list-tile-action>
                  <v-icon color="indigo">business</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-list-tile-title>Business / School</v-list-tile-title>
              </v-list-tile-content>

          </v-list-tile>

          <v-list-tile class="schoolSelection">
              <v-list-tile-action>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-card style="width:100%">
                      <v-card-title>
                          Select An Existing Business

                          <v-spacer></v-spacer>
                          <v-text-field
                                  v-model="search"
                                  append-icon="search"
                                  label="Search"
                                  single-line
                                  hide-details
                          ></v-text-field>

                          <v-spacer></v-spacer>
                          <v-btn :disabled="tripData.disabled" @click="editingBusinessID = null; newBussinessDialog = true" color="primary">Create New</v-btn>
                      </v-card-title>
                      <v-data-table
                          :disabled="tripData.disabled"
                              :headers="headers"
                              :items="businesses"
                              :search="search"
                      >
                          <template slot="items" slot-scope="props">
                              <tr  :key="props.index" @click="setSelectedBusiness(props.item._id)"
                                  v-bind:class="{'active-school': props.item._id == tripData.selectedBusiness}">
                              <td>{{ props.item.name }}</td>
                              <td class="text-xs-center">{{ props.item.address }}</td>
                              <td class="text-xs-right">{{ props.item.notes }}</td>
                              </tr>
                          </template>
                          <v-alert slot="no-results" :value="true" color="error" icon="warning">
                              Your search for "{{ search }}" found no results.
                          </v-alert>
                      </v-data-table>
                  </v-card>

              </v-list-tile-content>

          </v-list-tile>





          <v-list-tile class="mainSectionHeadingInList" @click="">
              <v-list-tile-action>
                  <v-icon color="indigo">person</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-list-tile-title>Select Directors For This Trip</v-list-tile-title>
              </v-list-tile-content>

          </v-list-tile>

          <v-container fluid>
              <v-checkbox :disabled="tripData.disabled" v-if="directorList.length > 0" v-for="director in directorList" v-model="directorsOnTrip"  :label="director.firstName + ' ' + director.lastName + ' (' + director.email + ')'" :value="director._id"></v-checkbox>
              <p v-if="this.tripData.selectedBusiness == null">Select a business above</p>

              <p v-if="this.tripData.selectedBusiness  != null && directorList.length == 0" >No directors are attached to this business</p>

            <v-btn v-show="this.tripData.selectedBusiness  != null" :disabled="tripData.disabled" @click="openAddDirector()" color="primary">Add New Director</v-btn>

          </v-container>


          <v-list-tile class="mainSectionHeadingInList" @click="">
              <v-list-tile-action>
                  <v-icon color="indigo">question_answer</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-list-tile-title>Custom Questions</v-list-tile-title>
              </v-list-tile-content>

          </v-list-tile>



          <v-list-tile class="schoolSelection" >
              <v-list-tile-action>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-card style="width:100% ">
                  <v-container fluid >
                      <v-layout wrap align-center >
                          <v-flex xs5 >

                              <h4 class="">Enter Group Type Heading</h4>

                              <v-text-field
                                      v-validate="'required'"
                                      value="Select Your Group Type"
                                      v-model="tripData.customOptionsTitle"
                                      label="Group Type"
                                      required
                                      :disabled="tripData.disabled"
                              ></v-text-field>

                              <br/>

                              <div v-if="tripData.customOptionsTitle.length > 0">

                                  <h4 class="">Enter choices users will see for the dropdown</h4>


                                  <v-layout row v-for="option in tripData.customOptions">
                                      <v-flex xs9 >
                                          <v-text-field
                                                  label="Label"
                                                  single-line
                                                  v-model="option.label"
                                                  hide-details
                                                  :disabled="tripData.disabled"
                                          ></v-text-field>
                                      </v-flex>

                                      <v-flex xs2 >
                                          <v-btn :disabled="tripData.disabled" @click="removeCustomOption(option)" class="ma-0 pa-0" fab dark small color="primary" >
                                              <v-icon class="ma-0 pa-0" dark>close</v-icon>
                                          </v-btn>
                                      </v-flex>
                                  </v-layout>

                                  <v-layout row >
                                      <v-flex xs9 >

                                          <v-text-field
                                                  v-model="newCustomOption"
                                                  label="New Choice"
                                                  single-line
                                                  hide-details
                                                  :disabled="tripData.disabled"
                                          ></v-text-field>
                                      </v-flex>

                                      <v-flex xs2>
                                          <v-btn :disabled="tripData.disabled" @click="addCustomOption" class="ma-0 pa-0" fab dark small color="primary" >
                                              <v-icon class="ma-0 pa-0" dark>add</v-icon>
                                          </v-btn>
                                      </v-flex>
                                  </v-layout>
                              </div>
                          </v-flex>
                          <v-flex xs1></v-flex>

                          <v-flex xs6 v-if="tripData.customOptionsTitle.length > 0">

                              <h4 class="text-xs-center">This is a preview of what a user will see</h4>

                              <v-card>
                                  <v-container>

                                      <h5>{{tripData.customOptionsTitle}}:</h5>
                                      <v-layout row wrap justify-space-around>

                                          <v-checkbox v-for="option in tripData.customOptions"
                                                      hide-details :label="option.label" ></v-checkbox>

                                      </v-layout>
                                  </v-container>
                              </v-card>
                          </v-flex>

                      </v-layout>
                  </v-container>
                  </v-card>
              </v-list-tile-content>

          </v-list-tile>

          <v-list-tile class="mainSectionHeadingInList" @click="">
              <v-list-tile-action>
                  <v-icon color="indigo">attach_money</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-list-tile-title>Pricing</v-list-tile-title>
              </v-list-tile-content>

          </v-list-tile>

          <v-list-tile @click="">
              <v-list-tile-action>
              </v-list-tile-action>



              <v-list-tile-content >

                  <v-text-field
                      :disabled="tripData.disabled"
                          v-validate="'required'"
                          v-model="tripData.quadPrice"
                          type="number"
                          label="4 per room: $"
                          required
                  ></v-text-field>

              </v-list-tile-content>


              <v-list-tile-content>
                  <v-text-field
                      :disabled="tripData.disabled"
                          v-validate="'required'"
                          v-model="tripData.triplePrice"
                          type="number"
                          label="3 per room: $"
                          required
                  ></v-text-field>
              </v-list-tile-content>

              <v-list-tile-content>
                  <v-text-field
                      :disabled="tripData.disabled"
                          v-validate="'required'"
                          v-model="tripData.doublePrice"
                          type="number"
                          label="2 per room: $"
                          required
                  ></v-text-field>
              </v-list-tile-content>


              <v-list-tile-content>
                  <v-text-field
                      :disabled="tripData.disabled"
                          v-validate="'required'"
                          v-model="tripData.singlePrice"
                          type="number"
                          label="1 per room: $"
                          required
                  ></v-text-field>
              </v-list-tile-content>

            <v-list-tile-content>
              <v-checkbox class="ma-5"
                          v-model="tripData.lateFeesDisabled"
                          hide-details label= 'Disable Late Fees'></v-checkbox>
            </v-list-tile-content>




          </v-list-tile>

          <v-divider inset></v-divider>



          <v-list-tile class="mainSectionHeadingInList" @click="">
              <v-list-tile-action>
                  <v-icon color="indigo">date_range</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-list-tile-title>Payment Dates</v-list-tile-title>
              </v-list-tile-content>

          </v-list-tile>

          <v-list-tile @click="">
              <v-list-tile-action>
              </v-list-tile-action>


              <v-list-tile-content>
                  <v-dialog
                      :disabled="tripData.disabled"
                          ref="dialogPDD0"
                          v-model="modalPDD0"
                          :return-value.sync="tripData.depositPaymentDueDate"
                          persistent
                          lazy
                          full-width
                          width="290px"
                  >
                      <v-text-field
                              slot="activator"

                              :value="formatDate(tripData.depositPaymentDueDate)"
                              label="Deposit Due Date"
                              prepend-icon="event"
                              readonly
                      ></v-text-field>
                      <v-date-picker v-model="tripData.depositPaymentDueDate" :max="toISO(tripData.departDate, 0)" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modalPDD0 = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.dialogPDD0.save(tripData.depositPaymentDueDate);  tripData.firstPaymentDueDate = tripData.depositPaymentDueDate">OK</v-btn>
                      </v-date-picker>
                  </v-dialog>
              </v-list-tile-content>


              <v-list-tile-content>
                  <v-dialog
                      :disabled="tripData.disabled"
                          ref="dialogPDD1"
                          v-model="modalPDD1"
                          :return-value.sync="tripData.firstPaymentDueDate"
                          persistent
                          lazy
                          full-width
                          width="290px"
                  >
                      <v-text-field
                              slot="activator"

                              :value="formatDate(tripData.firstPaymentDueDate)"
                              label="First Payment Due Date"
                              prepend-icon="event"
                              readonly
                      ></v-text-field>
                      <v-date-picker v-model="tripData.firstPaymentDueDate" :min="toISO(tripData.depositPaymentDueDate, 0)" :max="toISO(tripData.departDate, 0)" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modalPDD1 = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.dialogPDD1.save(tripData.firstPaymentDueDate); tripData.secondPaymentDueDate = tripData.firstPaymentDueDate">OK</v-btn>
                      </v-date-picker>
                  </v-dialog>
              </v-list-tile-content>


              <v-list-tile-content>
                  <v-dialog
                      :disabled="tripData.disabled"
                          ref="dialogPDD2"
                          v-model="modalPDD2"
                          :return-value.sync="tripData.secondPaymentDueDate"
                          persistent
                          lazy
                          full-width
                          width="290px"
                  >
                      <v-text-field
                              slot="activator"
                              :value="formatDate(tripData.secondPaymentDueDate)"
                              label="Second Payment Due Date"
                              prepend-icon="event"
                              readonly
                      ></v-text-field>
                      <v-date-picker :max="toISO(tripData.departDate, 0)" :min="toISO(tripData.firstPaymentDueDate, 0)" v-model="tripData.secondPaymentDueDate" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modalPDD2 = false">Cancel</v-btn>
                          <v-btn flat color="primary"
                                 @click="$refs.dialogPDD2.save(tripData.secondPaymentDueDate); tripData.thirdPaymentDueDate = tripData.secondPaymentDueDate"
                          >OK</v-btn>
                      </v-date-picker>
                  </v-dialog>

              </v-list-tile-content>


              <v-list-tile-content>
              <v-dialog
                  :disabled="tripData.disabled"
                      ref="dialogPDD3"
                      v-model="modalPDD3"
                      :return-value.sync="tripData.thirdPaymentDueDate"
                      persistent
                      lazy
                      full-width
                      width="290px"
              >
                  <v-text-field
                          slot="activator"
                          :value="formatDate(tripData.thirdPaymentDueDate)"
                          label="Third Payment Due Date"
                          prepend-icon="event"
                          readonly
                  ></v-text-field>
                  <v-date-picker :max="toISO(tripData.departDate, 0)" :min="toISO(tripData.secondPaymentDueDate, 0)" v-model="tripData.thirdPaymentDueDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modalPDD3 = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialogPDD3.save(tripData.thirdPaymentDueDate); tripData.finalPaymentDueDate = tripData.thirdPaymentDueDate">OK</v-btn>
                  </v-date-picker>
              </v-dialog>
              </v-list-tile-content>


              <v-list-tile-content>
                  <v-dialog
                      :disabled="tripData.disabled"
                          ref="dialogPDD4"
                          v-model="modalPDD4"
                          :return-value.sync="tripData.finalPaymentDueDate"
                          persistent
                          lazy
                          full-width
                          width="290px"
                  >
                      <v-text-field
                              slot="activator"
                              :value="formatDate(tripData.finalPaymentDueDate)"
                              label="Final Payment Due Date"
                              prepend-icon="event"
                              readonly
                      ></v-text-field>
                      <v-date-picker :max="toISO(tripData.departDate, 0)"  :min="toISO(tripData.thirdPaymentDueDate, 0)" v-model="tripData.finalPaymentDueDate" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modalPDD4 = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.dialogPDD4.save(tripData.finalPaymentDueDate)">OK</v-btn>
                      </v-date-picker>
                  </v-dialog>
              </v-list-tile-content>
          </v-list-tile>


          <v-list-tile class="mainSectionHeadingInList" @click="">
              <v-list-tile-action>
                  <v-icon color="indigo">subject</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-list-tile-title>Documents</v-list-tile-title>
              </v-list-tile-content>

          </v-list-tile>
          <v-list-tile class="schoolSelection" v-if="this.$userData.permissions.includes('admin') || this.$userData.permissions.includes('sales')" >
              <v-list-tile-action>
              </v-list-tile-action>

              <v-list-tile-content>
                  <v-card style="width:100% ">
                      <v-container fluid >
                          <v-layout wrap align-center   v-for="form in documentList" style="border-bottom: grey 1px solid">
                             <v-flex xs1>
                                 <v-checkbox :disabled="tripData.disabled"  class="ma-1" v-model="form.enabled"
                                              hide-details label= ''></v-checkbox>
                             </v-flex>
                              <v-flex>
                                  <h4>{{form.name}}</h4>
                              </v-flex>
                              <v-flex xs5 v-show="!form.enabled">
                                  <p>Check any documents this trip needs for further options</p>
                              </v-flex>
                              <v-flex xs2 v-show="form.enabled">
                                  <v-checkbox :disabled="tripData.disabled" class="ma-1" v-model="form.mandatory"
                                               hide-details label= 'Mandatory'></v-checkbox>
                              </v-flex>
                              <v-flex xs3 v-show="form.enabled">
                                  <v-radio-group :disabled="tripData.disabled" v-model="form.applyTo"  row>
                                      <v-radio
                                              label="Directors"
                                              value="director"
                                      ></v-radio>
                                      <v-radio
                                              label="Adults"
                                              value="adult"
                                      ></v-radio>
                                  </v-radio-group>
                              </v-flex>
                          </v-layout>
                      </v-container>
                  </v-card>
              </v-list-tile-content>
          </v-list-tile>

        <v-list-tile class="mainSectionHeadingInList" @click="">
          <v-list-tile-action>
            <v-icon color="indigo">subject</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Public Notes</v-list-tile-title>
          </v-list-tile-content>

        </v-list-tile>
        <v-list-tile class="schoolSelection" v-if="this.$userData.permissions.includes('admin')" >
          <v-list-tile-action>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-card style="width:100% ">
              <v-container fluid >
                <v-layout wrap row >
                  <v-flex xs12>
                    <froala :tag="'textarea'" v-model="tripData.publicNotes"></froala>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      </v-card>
 <br/>

    <v-btn small color="red" v-if="isExisting && !tripData.disabled" @click="disableTrip"
    >
      Close Trip
    </v-btn>
    <v-btn color="green" dark v-else-if="isExisting && tripData.disabled" @click="enableTrip"
    >
      Open Trip
    </v-btn>

      <v-btn v-if="!isExisting && !tripData.disabled" @click="createTrip"
             color="primary"
      >
          Create New Trip!
      </v-btn>
      <v-btn v-else-if="!tripData.disabled" @click="updateTrip"
             color="primary"
      >
          Update Trip!
      </v-btn>
    <br/>



      <br/>
  </section>

</template>

<script lang="js">
    import moment from 'moment'
    import newBusiness from '../pages/NewBusiness'
  export default  {
    name: 'new-trip',
    props: [],
      components: {
          newBusiness
      },
    mounted() {
        var thisVue = this;
        this.$services.forms.find().then((result) => {
            console.log('got the forms', result)
            result.data.forEach((form) => {
                    form.enabled = false
                    form.applyTo = 'adult'
                    form.content = undefined
                    form.lastEdit = undefined
                    form.mandatory = false
                thisVue.documentList.push(form)
                })


            this.$services.businesses.find().then((test) => {
                console.log('fetched these', test)
              if(this.$userData.permissions.includes('admin')) {
                thisVue.businesses = test.data
              } else {
                thisVue.businesses = test.data.filter((x)=>this.$feathers.get('user').businesses.includes(x._id))
              }

              console.log('users trips these', thisVue.businesses)
                if(thisVue.isExisting) {
                    thisVue.populateTripData(thisVue.$route.params.id)
                }
            }).catch(function(error){
                console.error('Error!', error);
            });

        })


    },
    data() {
      return {
          documentList: [],
          editingBusinessID: null,
          newCustomOption: '',
          forms: [],
          directorsOnTrip: [],
          search: '',
          headers: [
              {
                  text: 'Business Or School Name',
                  align: 'left',
                  sortable: true,
                  value: 'name',
                  width: '30%'
              },
              { text: 'Address',
                  align: 'center',
                  sortable: false,
                  width: '30%',
                  value: 'address' },

              { text: 'Notes',
                  align: 'center',
                  width: '30%',
                  sortable: false,
                  value: 'notes' }
          ],
          businesses : [],
          newBussinessDialog: false,
          date: new Date().toISOString().substr(0, 10),
          tripData: {
              documents: [],
              customOptions: [],
              customOptionsTitle: '',
              selectedBusiness: null,
              disabled: false,
              tripID: '',
              tripName: '',
              returnDate: new Date().toISOString().substr(0, 10),
              departDate: new Date().toISOString().substr(0, 10),
              lateFeesDisabled: false,
              quadPrice: '',
              triplePrice: '',
              doublePrice: '',
              singlePrice: '',
              depositAmount: '',
              depositPaymentDueDate: new Date().toISOString().substr(0, 10),
              firstPaymentDueDate: new Date().toISOString().substr(0, 10),
              secondPaymentDueDate: new Date().toISOString().substr(0, 10),
              thirdPaymentDueDate: new Date().toISOString().substr(0, 10),
              finalPaymentDueDate: new Date().toISOString().substr(0, 10),
              comments: '',
          },
          menu: false,
          modalDepart: false,
          modalReturn: false,
          modalPDD0: false,
          modalPDD1: false,
          modalPDD2: false,
          modalPDD3: false,
          modalPDD4: false,
          items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
          businessDataFromModal: null
      }
    },
    methods: {
      openAddDirector() {
        this.editingBusinessID = this.tripData.selectedBusiness;
        this.newBussinessDialog = true
      },
      createBusiness() {
            var vueThis = this
            this.$services.businesses.create(this.businessDataFromModal).then((addedBusiness) => {
               this.newBussinessDialog = false
                this.businesses.push(addedBusiness)
                this.tripData.selectedBusiness = addedBusiness._id
                this.search = addedBusiness.name
                vueThis.$emit("alertUser", "success", "Business (" + addedBusiness.name + ") Created!!")
            }).catch(function(error){
                vueThis.$emit("error", "Sorry, there was an error processing your request. Please try again later.")
                console.error('Error!', error);
            });

        },
      updateBusiness() {
        var vueThis = this
        this.$services.businesses.patch(this.editingBusinessID, this.businessDataFromModal).then((addedBusiness) => {
          this.newBussinessDialog = false
          console.log('ran update business returnec', addedBusiness)
          for(let i = 0; i < vueThis.businesses.length; i++) {
            if(vueThis.businesses[i]._id == vueThis.editingBusinessID) {
              vueThis.businesses[i] = addedBusiness
            }
          }
          vueThis.editingBusinessID = null
          this.tripData.selectedBusiness = null
          this.tripData.selectedBusiness = addedBusiness._id
          vueThis.$emit("alertUser", "success", "Business (" + addedBusiness.name + ") Updated!!")
        }).catch(function(error){
          vueThis.$emit("error", "Sorry, there was an error processing your request. Please try again later.")
          console.error('Error!', error);
        });

      },
        toISO(date, adjustDay){

            var ajustedDate = new Date(date);
            ajustedDate.setDate(ajustedDate.getDate() + adjustDay);

            return ajustedDate.toISOString()

        },
        formatDate (date) {
            return date ? moment(date).format('MM/DD/YYYY') : ''
        },
        populateTripData(id) {
            this.tripData = this.$structuredData.trips.find( trip => trip._id === id);

            if (this.tripData.documents != undefined) {
                for(let i = 0; i < this.documentList.length; i++) {
                    console.log('on this doc', this.documentList[i])
                    var result = this.tripData.documents.find(doc => doc._id === this.documentList[i]._id)
                    console.log('find result', result)
                    if (result != undefined) {
                        this.documentList[i].enabled = result.enabled
                        this.documentList[i].mandatory = result.mandatory
                        this.documentList[i].applyTo = result.applyTo
                    }
                }
            } else {
                this.tripData.documents = []
            }
            var selectBiz = this.businesses.find(business => business._id == this.tripData.selectedBusiness )
            console.log('selected biz is', selectBiz)
            this.search = selectBiz.name
            console.log('populating existing data', this.tripData)
        },
        removeCustomOption(option) {
            for(var i =0; i < this.tripData.customOptions.length; i++) {
                if(this.tripData.customOptions[i].ID == option.ID) {
                    this.tripData.customOptions.splice(i, 1);
                    break;
                }
            }
        },
        addCustomOption() {
            if(this.newCustomOption.length > 3) {
                let ID = 0
                console.log('in add custom option', this.tripData.customOptions.length)
                if (this.tripData.customOptions.length > 0) {
                    ID = this.tripData.customOptions[this.tripData.customOptions.length - 1].ID + 1
                }
                this.tripData.customOptions.push({
                    "label": this.newCustomOption,
                    "ID": ID
                })
                this.newCustomOption = ''
            }
        },
        setSelectedBusiness (a){

            if (event.target.classList.contains('btn__content') || this.tripData.disabled) return;

            if (this.tripData.selectedBusiness ==a) {
                this.tripData.selectedBusiness = null
            } else {
                this.tripData.selectedBusiness = a
                console.log('selected...', a)
            }


        },
      disableTrip() {
          this.tripData.disabled = true;
          this.updateTrip()
      },
      enableTrip() {
        this.tripData.disabled = false;
        this.updateTrip()
      },
        updateTrip() {
            this.tripData.documents=[]
            this.documentList.forEach((doc)=>{
                if (doc.enabled) {
                    this.tripData.documents.push(doc)
                }
            })
            var vueThis = this;
            this.$services.trips.patch(this.tripData._id, this.tripData).then((test) => {
                console.log('test update', test)

                vueThis.inviteOrRemoveDirectors(test._id, test.tripID)

                vueThis.$emit("alertUser", "success", "Trip Updated!!")
                vueThis.$router.push('/')
            }).catch(function(error){
                console.error('update Error!', error);
                vueThis.$parent.alertUser("error", "Sorry, there was an error processing your request. Please try again later.")

            });
        },
        inviteOrRemoveDirectors(tripID, prettyID) {
            console.log('trip is zzzzzz', tripID)
            var vueThis = this
            this.directorsOnTrip.forEach((director) => {
                var trips = vueThis.$fetchUserByID(director).trips

                if(!trips.includes(tripID)) {
                    trips.push(tripID)

                    console.log('pushing with this trip', trips)

                    this.$services.users.patch(director,
                        {
                            "trips": trips,
                            "mostRecentAddedTripID":prettyID
                        }).then((test) => {
                        console.log('patched directoer', test)
                    }).catch(function (error) {
                        console.error('patched directoer Error!', error);
                    });
                }
            })
        },
        createTrip() {
            this.tripData.documents=[]
            this.documentList.forEach((doc)=>{
                if (doc.enabled) {
                    this.tripData.documents.push(doc)
                }
            })

            console.log('this is', this.tripData)
            if(
                this.tripData.tripID.length > 2 &&
                this.tripData.tripName.length > 5 &&
                this.tripData.quadPrice.length > 0 &&
                this.tripData.triplePrice.length > 0 &&
                this.tripData.doublePrice.length > 0 &&
                this.tripData.singlePrice.length > 0 &&
                this.tripData.depositAmount.length > 0 &&
                this.tripData.selectedBusiness != null
            ) {

                var vueThis = this;
                this.$services.trips.find({ query: {
                        $limit: 1,
                        tripID: "" + vueThis.tripData.tripID
                    }
                }).then((result) => {
                    console.log('trip look', result.data)
                    if(result.data.length ==0) {
                        this.$services.trips.create(this.tripData).then((test) => {
                            vueThis.inviteOrRemoveDirectors(test._id, test.tripID)
                            vueThis.$emit("alertUser", "success", "Created Trip (" + vueThis.tripData.tripID + ")")
                            vueThis.$router.push('/')
                            console.log('test', test)
                        }).catch(function(error){
                            console.error('Error!', error);
                        });
                    } else {
                        this.$emit("alertUser", "error", "Trip ID " + vueThis.tripData.tripID + " Already Exists")
                    }
                })
            } else {
                this.$emit("alertUser", "error", "All fields are required")
            }

        }

    },
    computed: {
        tripInviteLink() {
          if(this.isExisting) {
            let route = this.$router.resolve({ name: 'tripinfo', params: { id: this.tripData._id } })
            return new URL(route.href, window.location.origin).href;
          } else {
            return 'This populates after creating the trip'
          }

        },
        directorList() {
            var toReturn = []
            var vueThis = this

            this.businesses.forEach((business)=>{
                if(business._id == this.tripData.selectedBusiness) {
                    business.directors.forEach((director)=>{
                        console.log('fetching this user from dir list', director)
                        var toAdd = vueThis.$fetchUserByID(director)
                        console.log('director list says', toAdd)
                        if(toAdd != undefined) {
                            toReturn.push(toAdd)
                            if(this.tripData._id != undefined && toAdd.trips.includes(this.tripData._id)) {
                                vueThis.directorsOnTrip.push(director)
                            }
                        }
                    })
                    console.log('returning', toReturn)
                }
            })

            return toReturn

        },
        isExisting() {
            if (this.$route.name == "updatetrip") {
                return true;
            }
            else {
                this.tripData =  {
                    customOptions: [],
                    customOptionsTitle: '',
                    selectedBusiness: null,
                    tripID: '',
                    tripName: '',
                    returnDate: new Date().toISOString().substr(0, 10),
                    departDate: new Date().toISOString().substr(0, 10),
                    quadPrice: '',
                    triplePrice: '',
                    doublePrice: '',
                    singlePrice: '',
                    depositAmount: '',
                    participantLimit: '999',
                    participantCount: 0,
                    depositPaymentDueDate: new Date().toISOString().substr(0, 10),
                    firstPaymentDueDate: new Date().toISOString().substr(0, 10),
                    secondPaymentDueDate: new Date().toISOString().substr(0, 10),
                    thirdPaymentDueDate: new Date().toISOString().substr(0, 10),
                    finalPaymentDueDate: new Date().toISOString().substr(0, 10),
                    comments: '',
                }
                return false;
            }
        }
    }
}
</script>

<style>

    .schoolSelection > div:first-child {
        height: 100%;
    }


</style>

<style scoped lang="scss">
  .new-trip {

  }

  .schoolSelection tr {
      cursor: pointer !important;
  }

  .active-school {
      background: #4285f4b5 !important;
      border-left: black 3px solid !important;
  }

  .active-school:hover {
      background: #4285f4b5 !important;
  }

</style>
